import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  DOCUMENT_SETUP_CLEAR_ALL_STATE,
  SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { fetchAttachmentsSuccess } from '@app/store/document/attachments/actions';
import { fetchSigningProgressInformationSuccess } from '@app/store/signingProgressInformation/actions';
import { scheduledDocumentPreviewDataFetched } from '@app/store/template/actions';

import { RequesterAttachment } from '../RequesterAttachment';

export const requesterAttachmentsEntityAdapter = createEntityAdapter<RequesterAttachment>();

const slice = createSlice({
  initialState: requesterAttachmentsEntityAdapter.getInitialState(),
  name: 'requesterAttahcments',
  reducers: {
    addRequesterAttachments(state, action: PayloadAction<Array<RequesterAttachment>>) {
      return requesterAttachmentsEntityAdapter.addMany(state, action.payload);
    },
    deleteRequesterAttachment(state, action: PayloadAction<string>) {
      return requesterAttachmentsEntityAdapter.removeOne(state, action.payload);
    },
    setRequesterAttachments(state, action: PayloadAction<Array<RequesterAttachment>>) {
      return requesterAttachmentsEntityAdapter.setAll(state, action.payload);
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(
        SIGNING_PROGRESS_INFORMATION__FETCH_SUCCESS,
        (state, action: ReturnType<typeof fetchSigningProgressInformationSuccess>) =>
          requesterAttachmentsEntityAdapter.setAll(state, action.payload.requesterAttachments)
      )
      .addCase(fetchAttachmentsSuccess, (state, action) =>
        requesterAttachmentsEntityAdapter.setAll(state, action.payload.requesterAttachments)
      )
      .addCase(scheduledDocumentPreviewDataFetched, (state, action) =>
        requesterAttachmentsEntityAdapter.setAll(state, action.payload.requesterAttachments)
      )
      .addCase(DOCUMENT_SETUP_CLEAR_ALL_STATE, () =>
        requesterAttachmentsEntityAdapter.getInitialState()
      ),
});

export default slice.reducer;

export const { addRequesterAttachments, deleteRequesterAttachment, setRequesterAttachments } =
  slice.actions;
